import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.array.for-each.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.object.define-property.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { FormManager } from "./FormManager";
import { CommunicationService } from "../Services/CommunicationService";
export var ModalBuilder = /*#__PURE__*/function () {
  function ModalBuilder() {
    _classCallCheck(this, ModalBuilder);
  }

  _createClass(ModalBuilder, null, [{
    key: "BuildSendEmailModal",
    value: function BuildSendEmailModal(senderName, senderEmail) {
      var modal = "\n\t\t<div class=\"mpp-modal-wrapper\">\n\t\t\t<div class=\"mpp-modal-window\">\n\t\t\t\t<span class=\"mpp-modal-close-button\">&#10006;</span>\n\t\t\t\t<div class=\"mpp-modal-header\">\n\t\t\t\t\t<span class=\"mpp-modal-title\">Send Email to <span class=\"mpp-modal-recepient-name\"></span></span>\n\t\t\t\t</div>\n\t\t\t\t<form id=\"sendEmailForm\" class=\"mppw-form mppw-form-validate\">\n\t\t\t\t\t<input type=\"hidden\" id=\"title\" name=\"title\" value=\"-1\" />\n\t\t\t\t\t<input type=\"hidden\" id=\"EmailToContactId\" name=\"EmailToContactId\" value=\"-1\" />\n\t\t\t\t\t<input type=\"hidden\" id=\"EmailFromContactId\" name=\"EmailFromContactId\" value=\"-1\" />\n\t\t\t\t\t<input type=\"hidden\" id=\"RecepientName\" name=\"RecepientName\" value=\"-1\" />\n\t\t\t\t\t<input type=\"hidden\" id=\"RecepientEmailAddress\" name=\"RecepientEmailAddress\" value=\"-1\" />\n\t\t\t\t\t<div class=\"mpp-modal-body\">";

      if (senderName && senderEmail) {
        modal += "\n\t\t\t<div class=\"mpp-modal-row mpp-modal-row-padding-left\">\n\t\t\t\t<b>From: </b> ".concat(senderName, "\n\t\t\t</div>\n\t\t\t<div class=\"mpp-modal-row mpp-modal-row-padding-left\">\n\t\t\t\t<b>Email Address: </b> ").concat(senderEmail, "\n\t\t\t</div>\n\t\t\t");
      } else {
        modal += "<div class=\"mpp-modal-row mppw-form-field\">\n\t\t\t\t\t\t\t<input name=\"SenderFirstName\" id=\"senderFirstName\" class=\"mpp-modal-input mppw-form-field__control\" required/>\n\t\t\t\t\t\t\t<label class=\"mppw-form-field__label\" for=\"SenderFirstName\">First Name*</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"mpp-modal-row mppw-form-field\">\n\t\t\t\t\t\t\t<input name=\"SenderLastName\" id=\"senderLastName\" class=\"mpp-modal-input mppw-form-field__control\" required/>\n\t\t\t\t\t\t\t<label class=\"mppw-form-field__label\" for=\"SenderLastName\">Last Name*</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"mpp-modal-row mppw-form-field\">\n\t\t\t\t\t\t\t<input type=\"email\" name=\"SenderEmailAddress\" id=\"senderEmailAddress\" class=\"mpp-modal-input mppw-form-field__control\" required/>\n\t\t\t\t\t\t\t<label class=\"mppw-form-field__label\" for=\"SenderEmailAddress\">Email Address*</label>\n\t\t\t\t\t\t</div>";
      }

      modal += "\n\t\t\t\t\t\t<div class=\"mpp-modal-row mppw-form-field\">\n\t\t\t\t\t\t\t<input name=\"EmailSubject\" id=\"emailSubject\" class=\"mpp-modal-input mppw-form-field__control\" required/>\n\t\t\t\t\t\t\t<label class=\"mppw-form-field__label\" for=\"EmailSubject\">Subject*</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"mpp-modal-row mppw-form-field\">\n\t\t\t\t\t\t\t<textarea name=\"EmailBody\" id=\"emailBody\" class=\"mpp-modal-input mppw-form-field__control\" rows=\"10\" required></textarea>\n\t\t\t\t\t\t\t<label class=\"mppw-form-field__label\" for=\"emailBody\">Your Message*</label>\n\t\t\t\t\t\t\t<div class=\"mppw-textarea-counter\" style=\"display: none\"></div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"mpp-modal-footer\">\n\t\t\t\t\t\t<input type=\"submit\" class=\"mppw-btn primary mpp-modal-send-button\" value=\"SEND\" />\n\t\t\t\t\t</div>\n\t\t\t\t</form>\n\t\t\t</div>\n\t\t</div>";
      return modal;
    }
  }, {
    key: "BindEmailModalEvents",
    value: function BindEmailModalEvents(_root, _eventData, _resultMessageContainer, _resultMessageText, _userProfile) {
      var _this = this;

      var _$sendEmailForm = _root.querySelector("#sendEmailForm");

      var sendEmailForm = new FormManager(_$sendEmailForm); // Bind contact card click handler to open email form modal

      var clickHandler = function clickHandler(id) {
        var contact = _eventData.contacts.find(function (x) {
          return x.contactId == id;
        });

        if (contact && contact.emailAddress) {
          var _$modal = _root.querySelector(".mpp-modal-wrapper");

          if (_$modal) {
            var titleName = contact.displayName.split(", ").reverse().join(" ");

            var recepientName = _$modal.querySelector(".mpp-modal-recepient-name");

            if (recepientName) {
              recepientName.innerHTML = titleName;
            }

            var contactId = _$modal.querySelector("#EmailToContactId");

            if (contactId) {
              contactId.value = contact.contactId;
            }

            var contactFromId = _$modal.querySelector("#EmailFromContactId");

            if (contactFromId && _userProfile) {
              contactFromId.value = _userProfile.contactId;
            }

            var contactName = _$modal.querySelector("#RecepientName");

            if (contactName) {
              contactName.value = titleName;
            }

            var contactEmail = _$modal.querySelector("#RecepientEmailAddress");

            if (contactEmail) {
              contactEmail.value = contact.emailAddress;
            }

            var messageTitle = _$modal.querySelector("#title");

            if (messageTitle) {
              messageTitle.value = _eventData.title;
            }

            _$modal.classList.add("mpp-modal-visible");
          }
        }
      };

      var _$contacts = _root.querySelectorAll(".mpp-innerpage--contact");

      _$contacts.forEach(function (el) {
        el.addEventListener("click", clickHandler.bind(_this, el.getAttribute("data-id")));
      }); // Bind modal close event. If user clicks outside of form - the modal will be closed


      var wrapper = _root.querySelector(".mpp-modal-wrapper");

      if (wrapper) {
        wrapper.addEventListener("click", function (ev) {
          var clickedPath = ev.composedPath().map(function (e) {
            return e.className;
          });
          if (clickedPath[0] !== "mpp-modal-wrapper mpp-modal-visible") return;
          sendEmailForm.Reset();
          wrapper.classList.remove("mpp-modal-visible");
        });
      }

      var closeBtn = _root.querySelector(".mpp-modal-close-button");

      if (closeBtn) {
        closeBtn.addEventListener("click", function (ev) {
          sendEmailForm.Reset();
          wrapper.classList.remove("mpp-modal-visible");
        });
      } // Bind email form submit event


      _$sendEmailForm.addEventListener("submit", function (event) {
        event.preventDefault();
        var communicationService = new CommunicationService();

        if (sendEmailForm.IsValid()) {
          var formData = new FormData(_$sendEmailForm);

          if (!formData.get("EmailToContactId")) {
            formData.set("EmailToContactId", 0);
          }

          communicationService.SendEmail(formData).then(function (emailResponse) {
            var wrapper = _root.querySelector(".mpp-modal-wrapper");

            sendEmailForm.Reset();
            wrapper.classList.remove("mpp-modal-visible");

            _resultMessageContainer.classList.remove("mppw-alert__success");

            _resultMessageContainer.classList.remove("mppw-alert__info");

            _resultMessageContainer.classList.remove("mppw-alert__warning");

            _resultMessageContainer.classList.remove("mppw-alert__danger");

            _resultMessageContainer.classList.add("mppw-alert__success");

            _resultMessageText.innerHTML = "Your message was successfully sent";
            _resultMessageContainer.style.display = "";
          })["catch"](function (error) {
            console.error(error);
            var errorMessage = "Failed to send the email message";

            _resultMessageContainer.classList.remove("mppw-alert__success");

            _resultMessageContainer.classList.remove("mppw-alert__info");

            _resultMessageContainer.classList.remove("mppw-alert__warning");

            _resultMessageContainer.classList.remove("mppw-alert__danger");

            _resultMessageContainer.classList.add("mppw-alert__danger");

            _resultMessageText.innerHTML = errorMessage;
            _resultMessageContainer.style.display = "";
          });
        } else {
          console.warn("Form is invalid!!!");
        }
      });
    }
  }]);

  return ModalBuilder;
}();